import { TripTypeEnum, VehicleType } from '@mopla/data-models';

import busIcon from './bus/Bus.svg?url';
import carBusinessIcon from './car/Business.svg?url';
import carEconomyIcon from './car/Economy.svg?url';
import carFirstIcon from './car/First.svg?url';
import comboIcon from './combo/Combo.svg?url';
import vanBusinessIcon from './van/Business.svg?url';
import vanLBODTFlexIcon from './van/LBODTFlex.svg?url';
import vanOnDemandIcon from './van/OnDemand.svg?url';
import vanRufbusIcon from './van/Rufbus.svg?url';
import schoolIcon from './van/School.svg?url';
import { ExtendedVehicleType, TServiceLbodtFlexVariant } from './types';

const modeIconMap: Record<string, string> = {
	[TripTypeEnum.LBT]: busIcon,
	[TripTypeEnum.LBODT]: vanRufbusIcon,
	[TripTypeEnum.SPECIAL_SCHOOL_TRAFFIC]: schoolIcon,
	MIXED: comboIcon,
};

const lbodtFlexIconMap: Record<string, string> = {
	LBODTFLEX: vanOnDemandIcon,
	LBODTFLEX_WITH_PASSENGERS: vanLBODTFlexIcon,
};

const vehicleTypeIconMap: Partial<Record<VehicleType, string>> = {
	[VehicleType.ECONOMY]: carEconomyIcon,
	[VehicleType.BUSINESS]: carBusinessIcon,
	[VehicleType.BUSINESS_VAN]: vanBusinessIcon,
	[VehicleType.FIRST_CLASS]: carFirstIcon,
};

export function resolveVehicleIconUrl(
	mode: TripTypeEnum | 'MIXED',
	vehicleType?: ExtendedVehicleType
): string | undefined {
	if (mode === TripTypeEnum.PRODT) {
		if (
			vehicleType &&
			Object.values(VehicleType).includes(vehicleType as VehicleType)
		) {
			return (
				vehicleTypeIconMap[vehicleType as VehicleType] ??
				vehicleTypeIconMap[VehicleType.ECONOMY]
			);
		}
		return vehicleTypeIconMap[VehicleType.ECONOMY];
	}

	if (mode === TripTypeEnum.LBODTFLEX) {
		const variant = (vehicleType as TServiceLbodtFlexVariant) ?? 'LBODTFLEX';
		return lbodtFlexIconMap[variant];
	}

	return modeIconMap[mode];
}
